export type ParsedError = {
  message: string;
  typeName?: string;
  isOperational?: boolean;
  ref?: string;
  rawError?: any;
};

export class HandleErrorsService {
  static parse(error: any): ParsedError {
    if (error.response?.data) {
      const data = error.response.data;

      return {
        message: this.mapMessage(data),
        typeName: data.typeName,
        isOperational: data.isOperational,
        ref: data.ref,
        rawError: error,
      };
    }

    if (error.request) {
      return {
        message: "No se recibió respuesta del servidor. Verifica tu conexión.",
        rawError: error,
      };
    }

    return {
      message: error.message || "Ocurrió un error desconocido.",
      rawError: error,
    };
  }

  static getUserMessage(error: any): string {
    return this.parse(error).message;
  }

  private static mapMessage(data: any): string {
    // Backend returns the message in data.error.message, data.message, or — QVET rejections (409) — data.error as a string
    const { statusCode, typeName, detail } = data;
    const message = data.error?.message || (typeof data.error === "string" ? data.error : undefined) || data.message;

    switch (typeName) {
      case "NOT_FOUND":
        return message || "Recurso no encontrado.";
      case "ValidationError":
        return detail || "Hay errores de validación.";
      case "InternalServerError":
        return detail || "Error interno del servidor.";
      default:
        if (statusCode === 500) return "Error del servidor. Intenta más tarde.";
        return message || "Ocurrió un error.";
    }
  }
}

export class HandleErrorsServiceLegacy {
  public static handleError(error: any) {
    console.error("Axios Error:", error);

    let errorTitle = "Error al registrar";
    let errorMessage = "";

    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      errorTitle = `Error ${error.response.status}`;
      // Backend returns message in data.error.message or data.message
      const data = error.response.data;
      const backendMessage =
        data?.error?.message || (typeof data?.error === "string" ? data.error : undefined) || data?.message;
      errorMessage = `Error: ${backendMessage || error.message}`;
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = "No response from server. Please try again later.";
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMessage = error.message;
    }

    return errorMessage;
  }
}
